import { FileBlockedError, type ScanData, type SwChatClient } from '@swchat/client-sdk';

/**
 * Quét tệp đã giải mã ngay trước khi lưu về máy. Nằm trong danh sách hash chặn → ném lỗi. Có phát hiện khác → hỏi người
 * dùng (`true` = vẫn lưu). Dùng cả cho Lưu trữ cá nhân: tệp cũ của chính họ vẫn lấy được sau khi hỏi.
 */
export async function confirmSave(client: SwChatClient, name: string, data: ScanData): Promise<boolean> {
  const { findings } = await client.scanFile(name, data);
  if (!findings.length) return true;
  const listed = findings.filter((f) => f.code === 'blocklist');
  if (listed.length) throw new FileBlockedError(name, listed);
  return window.confirm(`“${name}” có thể không an toàn:\n${findings.map((f) => `• ${f.message}`).join('\n')}\n\nChỉ mở nếu bạn tin nguồn của tệp. Vẫn tải về?`);
}
